import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PermCameraMicIcon(props: IconProps) {
    return <Icon {...props} iconKey={"perm_camera_mic"}/>
}
